import React, { } from 'react';
import { Stack } from 'office-ui-fabric-react';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import NewFormField from '../../common/layout/form/NewFormField';
import NewFormBtns from '../../common/layout/form/NewFormBtns';
import FormDropDown from '../../common/layout/form/FormDropDown';
import OrderDetailTxt from '../../orders/components/forms/edditOrder/OrderDetailTxt';
import ActivityIndicator from '../../common/layout/ActivityIndicator';
import MessageContainer from '../../auth/components/register/forms/MessageContainer';

interface IContainerEditForm {
    initValues: any;
    handleSubmit: any;
    cancelForm: any;
    loading: boolean,
    gpsDeviceStatuses: any
}

const ContainerEditForm: React.FC<IContainerEditForm> = ({ initValues, handleSubmit, cancelForm, loading, gpsDeviceStatuses }) => {
    const { t } = useTranslation("admin");

    return (
        <Formik
            initialValues={initValues}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            {({ handleSubmit }) => (
                <Form translate="yes" onSubmit={handleSubmit} >
                    <Stack>
                        <NewFormField name="containerNumber" label={t("nav.containerNumber") as string} required={false} />
                        <NewFormField name="description" label={t("nav.containerDesc") as string} multiline={true} required={false} />
                        <FormDropDown
                            name="status"
                            options={gpsDeviceStatuses}
                            headerText={t("nav.panelContainerStatus") as string}
                        />
                        <OrderDetailTxt
                            title={t("nav.iccidNumber")}
                            value={initValues.iccid}
                        />
                        <OrderDetailTxt
                            title={t("nav.imeiNumber")}
                            value={initValues.imei}
                        />
                        <OrderDetailTxt
                            title={t("nav.serialNumber")}
                            value={initValues.serNo}
                        />
                        <OrderDetailTxt
                            title={t("nav.lastActivity")}
                            value={initValues.lastActiveDateStr}
                        />
                        <NewFormBtns
                            cancelForm={cancelForm}
                            submitBtnText={t("nav.save") as string}
                            positionAbsolute={true}
                        />
                    </Stack>
                    {loading ? <ActivityIndicator /> : <MessageContainer />}
                </Form>
            )}
        </Formik>
    )
};

export default ContainerEditForm;